module.exports = __webpack_public_path__ + "static/media/UploadImage.c130f5dd.svg";